import { API_ENDPOINTS } from '@/utils/constants/constants';
import { Feedback } from '@phpcreation/frontend-components-react';
import axios from 'axios';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';

type Props = {};

const AnonymousFeedback = (props: Props) => {
  return (
    <>
      <Head>
        <title>Ticket Feedback - Anonymous</title>
      </Head>

      <Feedback
        ticketUrl={process.env.NEXT_PUBLIC_TICKET_URL ?? ''}
        feedbackUrl={process.env.NEXT_PUBLIC_FEEDBACK_URL ?? ''}
        fqcn_bui={{
          Bundle: 'ticketClient',
          Unit: 'feedback',
          Interface: 'form',
        }}
      />
    </>
  );
};

export default AnonymousFeedback;

// TODO
// export const getServerSideProps: GetServerSideProps = async context => {
//   const { data } = await axios.post(API_ENDPOINTS.auth, {
//     username: 'ticket-user-for-client-feedback',
//     password: 'cuteIvory80!',
//   });

//   if (data.token) {
//     context.res.setHeader(
//       'Set-Cookie',
//       `token=${data.token}; Path=/; HttpOnly`
//     );

//     return {
//       props: {
//         token: data.token,
//       },
//     };
//   }

//   return { props: {} };
// };
